import { createChatTransport } from "./mealChatTransport.mjs";
import { API_URL, ApiError, SIGNED_OUT_EVENT } from "../api/client";
import { clearToken, getToken } from "../api/token";

// Chat transport for the in-app assistants (athlete, scout). The agent decides
// the backend's tools and permissions; everything else is shared.
export const createAssistantChatTransport = (agent) =>
  createChatTransport({
    apiUrl: API_URL,
    agent,
    getToken,
    fetch: async (url, init) => {
      let response;
      try {
        response = await fetch(url, init);
      } catch (error) {
        if (error.name === "AbortError") throw error;
        throw new ApiError(
          0,
          "API_UNREACHABLE",
          "No podemos conectar con el servidor.",
        );
      }
      if (!response.ok) {
        if (response.status === 401) {
          clearToken();
          window.dispatchEvent(new Event(SIGNED_OUT_EVENT));
        }
        // The body is the backend's JSON error envelope ({ error, message,
        // details }). Keeping code/details lets the chat tell a plan's daily
        // limit or a missing plan (DEV-43) from any other failure.
        const payload = await response
          .clone()
          .json()
          .catch(() => null);
        const error = new ApiError(
          response.status,
          payload?.error || "ASSISTANT_ERROR",
          payload?.message || "No pudimos completar la consulta.",
          payload?.details,
        );
        error.retryAfter =
          Number(response.headers.get("Retry-After")) || undefined;
        throw error;
      }
      return response;
    },
  });

export const createAthleteChatTransport = () =>
  createAssistantChatTransport("athlete-assistant");
